import { render, staticRenderFns } from "./FooterNavbar.vue?vue&type=template&id=b914687e&"
import script from "./FooterNavbar.vue?vue&type=script&lang=js&"
export * from "./FooterNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports